import styled from "styled-components";
import { px2rem } from "../../utils/css";
export const transformBox = (Parentwrap) => {
    return styled(Parentwrap) `
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background-color: #fff;
		text-decoration: none;
		min-height: 5rem;
		padding: 0 !important;
	`;
};
export const FlexWrapper = styled.div `
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
export const TextSpan = styled.span `
	font-size: ${px2rem(14)};
	color: #999;
	line-height: 16px;
	margin-top: 0.25rem;
`;
